<template>
  <div class="staps_block">
      <div v-for="(item ,index) in orderStatus" class="steps_item">
          <div class="flex_row_center" style="height:60px">
              <div v-if="active-1>index" class="passed"></div>
              <div v-else class="todo"></div>
          </div>
          <div class="flex_row_center" style="height:40px;line-height:40px;">
              <div :class="[active>index?'done_text':'todo_text']">{{item}}</div>
          </div>
      </div>
  </div>
</template>


<script>
export default {
    data(){
        return {
            orderStatus:['已支付','待发货','已发货','待收货','已完成'],
            active:1,//当前进度
        }
    }
}
</script>


<style lang="scss" scoped>
.staps_block{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    background-color: inherit;
    .steps_item{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .flex_row_center{
        // position: relative;
        display: flex;
        // align-items: center;
        justify-content: center;
    }
    .passed{
        width:26px;
        height: 26px;
        background:#b5b5b5;
        border-radius: 50%;
        z-index:2;
    }
    
    .todo{
        width:26px;
        height: 26px;
        background:#4f7cbd;
        border-radius: 50%;
        z-index:2;
    }

    .passed::after{
        content:'';
        width:15%;
        height: 4px;
        background:#b5b5b5;
        position: absolute;
        top:28px;
        z-index:0;

    }
    .todo::after{
        content:'';
        width:18%;
        height: 4px;
        background:#b5b5b5;
        position: absolute;
        top:10px;
        z-index:0;
    }

    .steps_item:last-child .passed::after,
    .steps_item:last-child .todo::after{
        content:'';
        width:0;
        height: 0;;

    }

    .done_text{
        font-size:28px;
        color:#333;
    }
    .todo_text{
        font-size: 24px;
        color:#999;
    }

}


</style>


// WEBPACK FOOTER //
// src/components/process/process.vue